export const FIXED_BRIDGE_CHAT_TITLE = 'Bridge';
export const BRIDGE_CHAT_ONBOARDING_CONVERSATION_ID = 'bridge-chat';
